import { c as _c } from "react/compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import type { ContactChannelResp, HTTPValidationError } from '../model';
import { customFetch } from '../../fetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & {
  queryKey: K;
} => {
  const result = {
    queryKey
  } as T & {
    queryKey: K;
  };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};
export const getGetContactChannelUrl = () => {
  return `/api/v1/contact-channel`;
};

/**
 * @summary Get Contact Channel
 */
export const getContactChannel = async (options?: Parameters<typeof customFetch>[1]): Promise<ContactChannelResp> => {
  return customFetch<ContactChannelResp>(getGetContactChannelUrl(), {
    ...options,
    method: 'GET'
  });
};
export const getGetContactChannelQueryKey = () => {
  return [`/api/v1/contact-channel`] as const;
};
export const getGetContactChannelQueryOptions = <TData = Awaited<ReturnType<typeof getContactChannel>>, TError = HTTPValidationError>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getContactChannel>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetContactChannelQueryKey();
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactChannel>>> = ({
    signal
  }) => getContactChannel({
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getContactChannel>>, TError, TData> & {
    queryKey: QueryKey;
  };
};
export type GetContactChannelQueryResult = NonNullable<Awaited<ReturnType<typeof getContactChannel>>>;
export type GetContactChannelQueryError = HTTPValidationError;

/**
 * @summary Get Contact Channel
 */

export function useGetContactChannel(options) {
  const $ = _c(5);
  let t0;
  if ($[0] !== options) {
    t0 = getGetContactChannelQueryOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };
  let t1;
  if ($[2] !== query || $[3] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[2] = query;
    $[3] = queryOptions.queryKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}